module.exports = __webpack_public_path__ + "img/f5.d0e50e03.jpg";